import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {EditionsLexiClient, EditionTemplateListDto, EditionTemplatesLexiClient, ObjectType, ListEditionDto, EditionGenerateurType } from '@lexi-clients/lexi';
import notify from 'devextreme/ui/notify';
import {DownloadService} from 'lexi-angular/src/app/services/download.service';
import {ReportService} from 'lexi-angular/src/app/services/report.service';
import { AuthService } from 'lexi-angular/src/app/settings/auth.service';
import {lastValueFrom, Subscription} from 'rxjs';
import { NotificationType } from '../references/references';
import { HttpResponse } from '@angular/common/module.d-CnjH8Dlt';

@Component({
    selector: 'app-objecttype-edition-possible-list',
    templateUrl: './objecttype-edition-possible-list.component.html',
    styleUrls: ['./objecttype-edition-possible-list.component.scss'],
    standalone: false
})
export class ObjecttypeEditionPossibleListComponent implements OnDestroy {

  private _objectType: ObjectType;
  get objectType(): ObjectType {
    return this._objectType;
  }
  @Input() set objectType(value: ObjectType) {
    if (value) {
      this._objectType = value;
      this.loadData();
    }
  }


  private _objectId: number;
  get objectId(): number {
    return this._objectId;
  }
  /**
   * Identifiant de l'objet à éditer.
   *
   * Utiliser soit objectId pour 1 élément, soit objectIds pour une liste d'éléments
   */
  @Input() set objectId(value: number) {
    if (value) {
      this._objectId = value;
    }
  }

  /**
   * Liste des identifiants des objets à éditer.
   *
   * Utiliser soit objectId pour 1 élément, soit objectIds pour une liste d'éléments
   */
  @Input() objectIds: string[]|number[] = [];

  @Input() isDropDownButton = false;

  @Input() placeholder = 'Imprimer';
  @Output() templateIdSelected = new EventEmitter<string>();

  private readonly subscriptions = new Subscription();

  editionsPossible: EditionTemplateListDto[];

  constructor(
    private readonly editionTemplatesLexiClient: EditionTemplatesLexiClient,
    private readonly editionsLexiClient: EditionsLexiClient,
    private readonly downloadService: DownloadService,
    private readonly authService: AuthService,
    private readonly reportService: ReportService
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async loadData() {
    this.editionsPossible = await lastValueFrom(this.editionTemplatesLexiClient.getByObjectType(this.objectType));
  }

  async onDownloadEdition(selectedItem: { itemData: EditionTemplateListDto }) {
    if (selectedItem?.itemData == null) {
      notify({closeOnClick: true, message: "Édition introuvable." }, NotificationType.Error);
      return;
    }

    if (this.objectId == null && (this.objectIds == null || this.objectIds.length === 0)) {
      notify({closeOnClick: true, message: "Aucun élément n'a été sélectionné." }, NotificationType.Warning);
      return;
    }

    // On set l'objectId si on a qu'un seul élément dans la liste des objectIds
    if (this.objectId == null && this.objectIds?.length == 1 && !Number.isNaN(Number(this.objectIds[0]))) {
      this.objectId = Number(this.objectIds[0]);
    }

    const selectedEditionTemplate = selectedItem.itemData;
    const isSelectionMultiple = this.objectIds != null && this.objectIds.length > 1;
    let response: HttpResponse<Blob>;

    // Téléchargement pour une liste d'éléments
    if (isSelectionMultiple) {
      const dto: ListEditionDto = {
        editionTemplateId: selectedEditionTemplate.id,
        editionObjectIds: this.objectIds.map(id => ({ objectId: id, nombreTemplate: 1 }))
      };

      response = await lastValueFrom(this.editionsLexiClient.getByEditionTemplateAndObjectIdPOST(dto, 'response'));
    }
    // Ouverture du report viewer dans le cas d'un XtraReport
    else if (this.objectId != null && selectedEditionTemplate.editionGenerateurType === EditionGenerateurType.xtraReport) {
      this.reportService.open(selectedEditionTemplate.id, 'objectId=' + this.objectId + '&siteId=' + this.authService.currentSiteId);
      return;
    }
    // Téléchargement pour un seul élément
    else {
      response = await lastValueFrom(this.editionsLexiClient.getByEditionTemplateAndObjectIdGET(selectedEditionTemplate.id, this.objectId, 'response'));
    }

    this.downloadService.directDownloadFile(response);
  }

  handleEditionTemplateChange(e) {
    this.templateIdSelected.emit(e?.value);
  }
}
